import { Component, OnInit, Input, EventEmitter, Output, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from "rxjs";
import { tap } from "rxjs/operators";
import { IUploadFile, DocumentManagementService } from '../../../../common/services/document-management.service';
import { BlobDownloadRequest } from '../../../../common/models/onBaseIntegrationAndMapping.model';


@Component({
    selector: 'uploaded-file',
    templateUrl: './uploaded-file.component.html',
    styleUrls: ['./uploaded-file.component.scss'],
    standalone: false
})
export class UploadedFileComponent implements OnInit, OnDestroy {

    private _file: IUploadFile;

    @Input() allowFileDeletion: boolean = true;

    @ViewChild("downloadLink") public downloadLink: ElementRef;
    downloadSubscription: Subscription = new Subscription();

    get file(): IUploadFile {
        return this._file;
    }

    @Input() set file(data: IUploadFile) {
        this._file = data;
    }

    @Output() fileDeleted: EventEmitter<IUploadFile> = new EventEmitter<IUploadFile>();

    constructor(private service: DocumentManagementService) { }

    ngOnInit() {
    }

    ngOnDestroy() {
        if (this.downloadSubscription) this.downloadSubscription.unsubscribe();
    }


    deleteFile(): void {
        if (this.canDeleteFile()) {
            this.fileDeleted.emit(this.file);
        }
    }

    canDeleteFile() {
        return (this.allowFileDeletion && !this.file.sentToOnbase)
    }

    downloadFile(): void {
        //const download$ = this.service.downloadFile(this.file.blobUri).pipe(
        //    tap((data) => {
        //        const link = this.downloadLink.nativeElement;
        //        link.href = data;
        //        link.click();
        //    })
        //).subscribe(
        //    () => { console.log(`File ${this.file.fileName} downloaded`); },
        //    (error) => { console.error(error); });
        const download$ = this.service.downloadBlob({ uri: this.file.blobUri, contentType: this.file.type, fileName: this.file.fileName } as BlobDownloadRequest).pipe(
            tap((data) => { this.renderBlob(data, this.file.type, this.file.fileName); })
        ).subscribe(
            () => { console.log(`File ${this.file.fileName} downloaded`); },
            (error) => { console.error(error); });
        this.downloadSubscription.add(download$);
    }

    private renderBlob(data: any, contentType: string, fileName: string): void {
        const blob = new Blob([data], { type: contentType });
        let url = window.URL.createObjectURL(blob);
        const link = this.downloadLink.nativeElement;
        link.href = url;
        link.download = fileName;
        link.click();
    }
}
